export { Svg, Path } from 'react-native-svg'
